import { VariantProps, cva } from 'class-variance-authority'
import React, { HTMLAttributes, ReactNode, useRef } from 'react'

import { useScroll } from '@frame/lib/hooks/useScroll'
import { cn } from '@frame/lib/utils/cn'
import { ScrollArea } from '@radix-ui/react-scroll-area'

const variants = cva('relative bg-white', {
  variants: {
    hasBackgroundColor: {
      false: 'bg-transparent',
    },
  },
  defaultVariants: {
    hasBackgroundColor: true,
  },
})

type Props = {
  hasBackgroundColor?: VariantProps<typeof variants>['hasBackgroundColor']
  paddingTopOverride?: number
  children?: ReactNode
  rest?: HTMLAttributes<HTMLDivElement>
} & HTMLAttributes<HTMLDivElement>

export function Body({ paddingTopOverride, hasBackgroundColor, children, className, ...rest }: Props) {
  const paddingTop = paddingTopOverride !== undefined ? paddingTopOverride : 24
  const ref = useRef<HTMLDivElement | null>(null)
  const { isScrollAtBottom, isScrolling } = useScroll(ref, paddingTop)

  return (
    <ScrollArea
      id="scroll-area"
      className={cn(
        'h-full flex-1 overflow-y-auto',
        isScrollAtBottom && 'border-b-1.5 border-b-moss-200',
        isScrolling && 'border-t-1.5 border-t-moss-200'
      )}
      ref={ref}
    >
      <main {...rest} className={cn(className, variants({ hasBackgroundColor }))} style={{ paddingTop }}>
        {children}
      </main>
    </ScrollArea>
  )
}
